import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import SVG from 'react-inlinesvg';
import chevronBackIcon from '@lifesize/ux-assets/vectors/svgIcons/chevron-back.svg';
import fullScreenEnterIcon from '@lifesize/ux-assets/vectors/svgIcons/full-screen-enter.svg';
import Tooltip from 'components/Tooltip/Tooltip';
import InCallNotification from 'components/InCall/InCallNotification/InCallNotification';
import classes from './CallHeader.module.scss';

const messages = defineMessages({
  badCallQualityTitle: {
    id: 'components.inCallNotification.badCallQualityTitle',
    defaultMessage: 'Poor network connection'
  },
  badCallQuality: {
    id: 'components.inCallNotification.badCallQuality',
    defaultMessage: 'Please wait. The video will resume automatically once the network connection improves.'
  },
  offlineTitle: {
    id: 'components.inCallNotification.offlineTitle',
    defaultMessage: 'Trying to reconnect'
  },
  offlineWarning: {
    id: 'components.inCallNotification.offlineWarning',
    defaultMessage: 'Please wait. The network connection was lost but we are working to recover your call.'
  }
});

export const CallHeader = props => (
  <div
    className={props.isMinimized ?
      classes.minimizedHeaderContainer : classes.headerContainer}
    style={!props.videoLayout.isDualStreaming && !props.isMinimized ?
      { width: props.videoLayout.width } : null}
  >
    {props.title.length > 32 && <Tooltip label={props.title} className={classes.wrapTooltip} />}
    <div className={classes.buttonContainer} >
      {props.enableMinimize && !props.isMinimized ? (
        <button onClick={() => props.toggleMinimized()} >
          <SVG src={chevronBackIcon} data-testid="chevronBackIcon" />
          <Tooltip
            location="right"
            label={<FormattedMessage id="components.inCall.callHeader.returnToHome" defaultMessage="Return to Home" />}
            style={{ marginLeft: 8 }}
          />
        </button>
      ) : null}
    </div>
    <div className={classes.title}>
      {props.title}
    </div>
    {
      (!props.isMinimized && props.badCallQuality && props.isOnline) ?
        <InCallNotification
          errorMessage={props.intl.formatMessage(messages.badCallQualityTitle)}
        >
          <div>
            <h2 className={classes.badCallQualityTitle}>
              <FormattedMessage {...messages.badCallQualityTitle} />
            </h2>
            <div className={classes.badCallQualityLine}>
              <FormattedMessage {...messages.badCallQuality} />
            </div>
          </div>
        </InCallNotification> :
        null
    }
    {
      ((!props.isMinimized && !props.isOnline) || (!props.badCallQuality && props.isReconnecting)) ?
        <InCallNotification
          errorMessage={props.intl.formatMessage(messages.offlineTitle)}
        >
          <div>
            <h2 className={classes.badCallQualityTitle}>
              <FormattedMessage {...messages.offlineTitle} />
            </h2>
            <div className={classes.badCallQualityLine}>
              <FormattedMessage {...messages.offlineWarning} />
            </div>
          </div>
        </InCallNotification> :
        null
    }
    <div className={classes.buttonContainer}>
      {props.isMinimized ? (
        <button onClick={() => props.toggleMinimized()} >
          <SVG src={fullScreenEnterIcon} data-testid="fullScreenEnterIcon" />
          <Tooltip
            location="right"
            label={<FormattedMessage id="components.inCall.callHeader.expand" defaultMessage="Expand" />}
            style={{ marginLeft: 10 }}
          />
        </button>
      ) : null}
    </div>
  </div>
);

CallHeader.propTypes = {
  intl: PT.object,
  title: PT.string,
  enableMinimize: PT.bool,
  isMinimized: PT.bool,
  toggleMinimized: PT.func,
  videoLayout: PT.object,
  badCallQuality: PT.bool,
  isOnline: PT.bool,
  isReconnecting: PT.bool.isRequired
};

export default injectIntl(CallHeader);
